import { SortEnum } from './common';

export enum GendersEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  NON_BINARY = 'NON_BINARY'
}

export enum DonorTypesEnum {
  INDIVIDUAL_DONOR = 'INDIVIDUAL_DONOR',
  CORPORATE_PARTNER = 'CORPORATE_PARTNER',
  FOUNDATION_FUNDER = 'FOUNDATION_FUNDER'
}

export interface Donor {
  id: string;
  userId: string;
  firstName: string;
  lastName?: string;
  ageRange?: string;
  gender: GendersEnum;
  donorType: DonorTypesEnum;
  bio?: string;
  createdAt?: string;
  updatedAt?: string;
  organizationId?: string;
  voice?: string;
  institution?: string;
  relationshipStage?: string[];
  givingHistory?: string;
  motivation?: string;
  website?: string;
  previousEngagements?: string;
  interests?: string;
  focusArea?: string[];
  grantCycleStatus?: string;
  fundingPreference?: string[];
  impactMetricPreference?: string[];

  totalSimulations?: number;
}

export interface DonorProfilesRequest {
  page?: number;
  limit?: number;
  orderBy?: string;
  sort?: SortEnum;
  name?: string;
  ageRange?: string;
  gender?: GendersEnum;
  donorType?: DonorTypesEnum;
  userId?: string | string[];
  organizationId?: string | string[];
}

export interface DonorProfilesResponse {
  data: Donor[];
  limit: number;
  page: number;
  total: number;
}

export interface CreateDonorRequest {
  firstName: string;
  lastName?: string;
  ageRange?: string;
  gender: GendersEnum;
  donorType: DonorTypesEnum;
  bio?: string;
  relationshipStage?: string[];
  institution?: string;

  // Individual
  givingHistory?: string;
  motivation?: string;

  // Corporate Partner
  previousEngagements?: string;
  interests?: string;

  // Foundation Funder
  focusArea?: string[];
  grantCycleStatus?: string;
  fundingPreference?: string[];
  impactMetricPreference?: string[];
  website?: string;
}

export interface DonorTotalSimulationsResponse {
  donorProfileId: string;
  totalSimulations: number;
}

export interface GetFullDonorProfileByIdResponse extends Donor {
  simulationCount: number;
  latestSimulation: {
    id: string;
    title: string;
    practiceType: string;
    userId: string;
    callId: string;
    totalDuration: number;
    status: string;
    finishedAt: string;
    goals: string[];
    configuration: {
      donorType: string;
      ageRange: string;
      gender: string;
      donorGivingHistory: string;
      donorMotivation: string;
      relationshipStage: string;
      inputWebsiteOfCompany: string;
      inputWebsiteOfFoundation: string;
      founderFocusArea: string;
      pushiness: number;
      riskTolerance: number;
      receptiveness: number;
      timeSensitivity: number;
      additionalInformation: string;
    };
    scenario: {
      donorScenarioId: string;
      donorScenarioPromptId: string;
      level: string;
    };
    donorProfile: Donor; // TODO: Duplication
    createdAt: string;
    updatedAt: string;
  };
}
